import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const CalendarSchedulerIcon = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-5 w-5', className)}
    {...props}
  >
    <g clipPath="url(#clip0_415_6769)">
      <g opacity="0.08">
        <path
          d="M4.95271 20.1786C1.99061 20.1786 0.000244141 18.1883 0.000244141 15.2261V5.84553C0.000244141 2.88344 1.99057 0.893066 4.95271 0.893066H15.0476C18.0097 0.893066 20.0001 2.8834 20.0001 5.84553V15.2261C20.0001 18.1882 18.0097 20.1786 15.0476 20.1786H4.95271Z"
          fill="black"
        />
      </g>
      <path
        d="M4.95271 19.8217C1.99061 19.8217 0.000244141 17.8313 0.000244141 14.8692V5.4886C0.000244141 2.5265 1.99057 0.536133 4.95271 0.536133H15.0476C18.0097 0.536133 20.0001 2.52646 20.0001 5.4886V14.8692C20.0001 17.8313 18.0097 19.8217 15.0476 19.8217H4.95271Z"
        fill="url(#paint0_linear_415_6769)"
      />
      <path
        d="M0.000244141 5.53611V5.4886C0.000244141 2.5265 1.99057 0.536133 4.95271 0.536133H15.0476C18.0097 0.536133 20.0001 2.52646 20.0001 5.4886V5.53611H0.000244141Z"
        fill="#F4413D"
      />
      <g opacity="0.16">
        <path
          d="M15.0476 0.535889H4.95271C1.99061 0.535889 0.000244141 2.52622 0.000244141 5.48835V14.869C0.000244141 17.8311 1.99057 19.8214 4.95271 19.8214H15.0476C18.0097 19.8214 20.0001 17.8311 20.0001 14.869V5.48835C20.0001 2.52622 18.0097 0.535889 15.0476 0.535889ZM19.2858 14.869C19.2858 17.4436 17.6222 19.1071 15.0476 19.1071H4.95271C2.37807 19.1071 0.714526 17.4436 0.714526 14.869V5.48835C0.714526 2.91372 2.37807 1.25017 4.95271 1.25017H15.0476C17.6222 1.25017 19.2858 2.91372 19.2858 5.48835V14.869Z"
          fill="url(#paint1_linear_415_6769)"
        />
      </g>
      <path
        d="M6.99134 11.5663H7.8117C8.73456 11.5663 9.36917 10.9999 9.36917 10.2138C9.36917 9.45203 8.79309 8.91491 7.84096 8.91491C6.96705 8.91491 6.34668 9.44241 6.27348 10.2235H5.62886C5.71172 9.09065 6.60062 8.32886 7.86991 8.32886C9.11025 8.32886 10.0427 9.08564 10.0427 10.1306C10.0427 11.0145 9.47131 11.6491 8.5731 11.8102V11.8299C9.65202 11.8934 10.3456 12.5623 10.3456 13.5584C10.3456 14.7498 9.2813 15.5995 7.90919 15.5995C6.48814 15.5995 5.52636 14.7888 5.48242 13.6609H6.12705C6.1806 14.447 6.88884 15.0134 7.90454 15.0134C8.92489 15.0134 9.66736 14.4127 9.66736 13.5777C9.66736 12.6792 8.97415 12.1324 7.84132 12.1324H6.9917C6.99134 12.1327 6.99134 11.5663 6.99134 11.5663Z"
        fill="#413D3D"
      />
      <path
        d="M13.1585 9.14939H13.1389C13.0268 9.21762 11.8061 10.1015 11.2493 10.4483V9.73544C11.4593 9.60364 12.9532 8.54902 13.1485 8.43188H13.8028V15.4875H13.1582L13.1585 9.14939Z"
        fill="#413D3D"
      />
      <path
        opacity="0.24"
        d="M4.64294 4.10741C5.23466 4.10741 5.71434 3.62772 5.71434 3.036C5.71434 2.44428 5.23466 1.9646 4.64294 1.9646C4.05122 1.9646 3.57153 2.44428 3.57153 3.036C3.57153 3.62772 4.05122 4.10741 4.64294 4.10741Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M15.357 4.10741C15.9488 4.10741 16.4285 3.62772 16.4285 3.036C16.4285 2.44428 15.9488 1.9646 15.357 1.9646C14.7653 1.9646 14.2856 2.44428 14.2856 3.036C14.2856 3.62772 14.7653 4.10741 15.357 4.10741Z"
        fill="black"
      />
      <g opacity="0.16">
        <path
          d="M15.0476 0.535889H4.95271C1.99061 0.535889 0.000244141 2.52622 0.000244141 5.48835V14.869C0.000244141 17.8311 1.99057 19.8214 4.95271 19.8214H15.0476C18.0097 19.8214 20.0001 17.8311 20.0001 14.869V5.48835C20.0001 2.52622 18.0097 0.535889 15.0476 0.535889ZM19.6429 14.869C19.6429 17.6175 17.7961 19.4643 15.0476 19.4643H4.95271C2.20416 19.4643 0.357405 17.6175 0.357405 14.869V5.48835C0.357405 2.73981 2.20416 0.89305 4.95271 0.89305H15.0476C17.7961 0.89305 19.6429 2.73981 19.6429 5.48835V14.869Z"
          fill="black"
        />
      </g>
      <path
        d="M4.64301 3.39294C4.44588 3.39294 4.28589 3.23295 4.28589 3.03582V0.178654C4.28589 -0.0184739 4.44588 -0.178467 4.64301 -0.178467C4.84014 -0.178467 5.00013 -0.0184739 5.00013 0.178654V3.03578C5.00017 3.23291 4.84014 3.39294 4.64301 3.39294Z"
        fill="url(#paint2_linear_415_6769)"
      />
      <path
        d="M15.3571 3.39319C15.16 3.39319 15 3.2332 15 3.03607V0.178899C15 -0.0182298 15.16 -0.178223 15.3571 -0.178223C15.5542 -0.178223 15.7142 -0.0182298 15.7142 0.178899V3.03603C15.7142 3.23316 15.5542 3.39319 15.3571 3.39319Z"
        fill="url(#paint3_linear_415_6769)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_415_6769"
        x1="10.0001"
        y1="19.8206"
        x2="10.0001"
        y2="0.535019"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ECECEC" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_415_6769"
        x1="10.0001"
        y1="19.8204"
        x2="10.0001"
        y2="0.534775"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.06" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_415_6769"
        x1="4.64297"
        y1="3.39183"
        x2="4.64297"
        y2="-0.17958"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#DCDCDC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_415_6769"
        x1="15.3571"
        y1="3.39207"
        x2="15.3571"
        y2="-0.179336"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#DCDCDC" />
      </linearGradient>
      <clipPath id="clip0_415_6769">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CalendarSchedulerIcon;
